import { inject } from 'vue'

/**
 * 會員資訊上下文 Hook
 * 提供統一的方式注入會員相關數據
 *
 * 使用方式：
 * ```js
 * import { useMemberContext } from '@/use/useMemberContext'
 *
 * setup() {
 *   const { member, levelList, updateMemberTags } = useMemberContext()
 *   // ...
 * }
 * ```
 */
export function useMemberContext () {
  const memberTopInfo = inject('memberTopInfo')
  const member = inject('member')
  const levelList = inject('levelList', [])
  const rebateWalletBalance = inject('rebateWalletBalance', 0)
  const totalPaymentPriceSum = inject('totalPaymentPriceSum', 0)
  const pointWalletBalance = inject('pointWalletBalance', {})
  const pospalWalletBalance = inject('pospalWalletBalance', 0)
  const externalPointWalletBalance = inject('externalPointWalletBalance', '-')
  const reservationStatistic = inject('reservationStatistic', { total: [0], absence: [0] })
  const tags = inject('tags', [])
  const customTags = inject('customTags', [])
  const usePospal = inject('usePospal', false)
  const useExternalPoint = inject('useExternalPoint', false)
  const externalWalletName = inject('externalWalletName', '第三方儲值金')

  // 方法
  const updateMemberTags = inject('updateMemberTags')
  const fetchMemberTopInfo = inject('fetchMemberTopInfo')

  return {
    // 數據
    memberTopInfo,
    member,
    levelList,
    rebateWalletBalance,
    totalPaymentPriceSum,
    pointWalletBalance,
    pospalWalletBalance,
    externalPointWalletBalance,
    reservationStatistic,
    tags,
    customTags,
    usePospal,
    useExternalPoint,
    externalWalletName,

    // 方法
    updateMemberTags,
    fetchMemberTopInfo,
  }
}
